import React from 'react';
import {
  NodeKey,
  DecoratorNode,
  $applyNodeReplacement,
  LexicalNode,
} from 'lexical';
import { Attachment } from './Attachment';

export class AttachmentNode extends DecoratorNode<React.ReactNode> {
  __id: string;
  __reference: string;

  static getType() {
    return 'attachment';
  }

  static clone(node: AttachmentNode) {
    return new AttachmentNode(node.__id, node.__reference, node.__key);
  }

  constructor(id: string, reference: string, key?: NodeKey) {
    super(key);
    this.__id = id;
    this.__reference = reference;
  }

  createDOM() {
    return document.createElement('div');
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return <Attachment footnoteId={this.__reference} nodeKey={this.__key} />;
  }

  isInline(): boolean {
    return true;
  }
}

export const $createAttachmentNode = (id: string, reference: string) => {
  return $applyNodeReplacement(new AttachmentNode(id, reference));
};

export const $isAttachmentNode = (
  node: LexicalNode | null | undefined,
): node is AttachmentNode => {
  return node instanceof AttachmentNode;
};
